export default [
  'members',
  'achievements',
  'news'
]



// WEBPACK FOOTER //
// ./src/pmgc/activeModules.js